export const locale = {
  lang: 'en',
  data: {
    DEBTOR: {
      DEBTOR: 'Debtor',
      SEARCH_CLIENTS: 'Search your clients',
      ADD_NEW: 'Add new',
      BUSINESS_NAME: 'Business name',
      TAX_CODE_PREFIX: 'Tax code prefix',
      TAX_CODE: 'Tax code',
      CERTIFIED_EMAIL: 'Certified email',
      CONTACT_DATA: 'Please provide a contact who can confirm the invoice',
      FIRST_NAME: 'First name',
      LAST_NAME: 'Last name',
      EMAIL: 'Email',
      PHONE: 'Phone',
    },
    INVOICE: {
      INVOICE: 'Invoice',
      NUMBER: 'Number Invoice',
      MAX_FILE_SIZE: 'Maximum size 20 MB',
      INVOICE_DATE: 'Invoice date',
      DUE_DATE: 'Due Date',
      AMOUNT: 'Amount',
      INSTALLMENTS: 'Installment details',
      INSTALLMENT_NUMBER: 'Installment number',
      UPLOAD_INVOICE: 'Please click here to upload PDF invoice',
      DOWNLOAD_INVOICE: 'Download invoice pdf',
      REPLACE_INVOICE: 'Replace invoice pdf',
      INVOICE_PDF: 'Invoice pdf',
      SNACKBAR: {
        DEBTOR_ADDED: 'Debtor added successfully!',
        INVOICE_ADDED: 'Invoice added successfully!',
        INVOICE_EDITED: 'Invoice edited successfully!',
        ADDED: 'Invoice added successfully!',
        DELETED: 'Invoice deleted successfully!',
        NOT_DELETED: 'Error: invoice not deleted!',
        ATTACHMENT_ERROR: 'Error uploading file',
        ERROR: 'Error: retry!',
        ATTACHMENT: 'You must upload at least one XML invoice and all other mandatory document',
        DUE_DATE: 'You must enter an due date after tomorrow',
        ACTIVATED: 'You must be enabled by the CashMe team to be able to publish an invoice',
      },
    },
    AUCTION: {
      AUCTION: 'Auction',
      DAY_DELAY: 'Number days average delay',
      DAY_DELAY_HINT: 'Attenzione: modificando questo campo verrà aggiornato il valore minimo di vendita',
      SELL_INFO: 'Imposta il valore minimo a cui vorrai cedere il tuo credito (Offerta minima).',
      RANGE_INFO:
        'In base allo storico delle transazioni già effettuate sulla piattaforma,\n' +
        'si suggerisce un range di prezzo minimo compreso tra',
      AND: 'e',
      MINIMUM_BID: 'Minimum bid',
      SELL_NOW_PRICE: 'Sell now price',
      VALUE_HINT: 'Suggested Value',
      DISCOUNT_APPLIED: 'Discount applied',
    },
    OTHER_DOC: {
      MANDATORY_DOC: 'Mandatory documents',
      LOAD_DOC: 'Upload the following documents',
      MORE_DOC: 'Other mandatory documents',
      OTHER_DOC: 'Other documents',
      INFO:
        'Completa la pratica allegando altri documenti che ritieni utili al fine di velocizzare l\'ammissione della fattura all\'asta\n' +
        '(es. contratto di fornitura, eventuale bolla di accompagnamento).',
      DELIVERY_NOTE: 'Delivery note',
      DELIVERY_NOTE_CARRIER: 'Delivery note carrier signed by carrier',
      CUSTOMER_ORDER: 'Customer order',
      SUPPLY_CONTRACT: 'Supply contract',
      SDI_DELIVERY_RECEIPT: 'SDI delivery receipt',
      XML_INVOICE: 'Electronic invoice in xml format',
      XML_INVOICE_DOC: 'Electronic invoice in xml format',
      CLIENT_LEDGER: 'Client ledger',
      OTHER: 'Other',
      CUSTOMER_ORDER_CONFIRMATION: 'Customer order confirmation',
      WORK_PROGRESS: 'Work progress',
      RELEASE_GUARANTEE_LETTER: 'Release guarantee letter',
      CUSTOMER_EMAIL_EXCHANGE: 'Customer email exchange',
      ADD: 'Add',
      DELETE: 'Do you want to delete this attachment?',
      NO: 'No',
      YES: 'Yes',
      LABEL: {
        DELIVERY_NOTE: '# Delivery',
        CUSTOMER_ORDER: '# Order',
        SUPPLY_CONTRACT: '# Contract',
      },
      EXPIRATION_DATE_WARNING: 'Expired client ledger',
      MAX_FILE_SIZE: 'Maximum file size: 20MB',
    },
    ACTION: {
      CANCEL: 'Cancel',
      NEXT: 'Next',
      SAVE: 'Save',
      END: 'End',
      SEND: 'Send',
      PREVIOUS: 'Previous',
      CONTINUES_LATER: 'Continues later',
      CONTINUES_LATER_INFO: 'If you want to save a draft and check the data at another time click on',
    },
    ERROR: {
      REQUIRED: 'Field required',
      INVALID: 'Value invalid',
      EMAIL: 'Please enter a valid email address',
      TAX_CODE: {
        INVALID: 'Tax code invalid',
        FORMAT: 'Wrong format',
      },
      PHONE: 'Please enter a valid phone number',
      DATE: 'Please enter a valid date',
      MINIMUM_BID_1: 'Value must be between',
      MINIMUM_BID_2: 'and',
      SELL_NOW: 'Value must be between minimum bid and invoice amount',
    },
  },
};
